'use client';

const TIMELINE = [
  {
    year: '2014',
    title: 'Genèse',
    text: "S.E. MATAR ouvre son premier atelier à Anvers, rue Nationale. Trois artisans, une table, une vision : le cuir comme art de vivre.",
  },
  {
    year: '2018',
    title: 'Reconnaissance',
    text: "Première présentation au Made in Brussels Fair. Le sac « Signature Cognac » reçoit le prix de l'Artisanat d'Exception.",
  },
  {
    year: '2021',
    title: 'Expansion panafricaine',
    text: "Ouverture d'un second atelier à Dakar, en partenariat avec la maison sœur Asmao Style Cuir. Échange de savoir-faire entre les deux rives.",
  },
  {
    year: '2024',
    title: 'Smartest Capital',
    text: "Intégration au groupe Smartest Capital. La maison entre dans la « Ville Dorée » sans rien céder de son âme : toujours fait main, toujours numéroté.",
  },
];

export default function Maison() {
  return (
    <section
      id="maison"
      className="relative py-24 sm:py-32 bg-[#0a0a0f] border-t border-[#D4AF37]/10 overflow-hidden"
    >
      {/* Background gold accent */}
      <div
        className="absolute -top-1/4 -right-1/4 w-[600px] h-[600px] rounded-full opacity-[0.07] pointer-events-none"
        style={{
          background:
            'radial-gradient(circle, #D4AF37 0%, transparent 70%)',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 mb-20 items-end">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="block h-px w-10 bg-[#D4AF37]" />
              <span className="eyebrow">La Maison</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              <span className="text-gold-gradient">Une décennie</span>
              <br />
              <span className="text-[#F4E8C1]">de patience et d'or.</span>
            </h2>
          </div>
          <p className="text-[#F4E8C1]/70 font-light leading-relaxed">
            De l'atelier de la rue Nationale à la Maison Smartest Capital,
            l'histoire de MATAR STYLE CUIR est celle d'une obsession : ne
            jamais transiger sur la main, la matière, ni le temps. Chaque
            jalon ci-dessous a été posé sans hâte, comme on ponce une couture.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[19px] sm:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#D4AF37]/40 to-transparent sm:-translate-x-1/2" />

          {TIMELINE.map((t, idx) => {
            const left = idx % 2 === 0;
            return (
              <div
                key={t.year}
                className={`relative flex items-center gap-6 sm:gap-12 mb-12 last:mb-0 ${
                  left ? 'sm:flex-row' : 'sm:flex-row-reverse'
                }`}
              >
                {/* Dot */}
                <div className="absolute left-[15px] sm:left-1/2 -translate-x-1/2 z-10">
                  <div className="w-2 h-2 rounded-full bg-[#D4AF37] glow-gold" />
                </div>

                {/* Spacer for centering */}
                <div className="hidden sm:block sm:w-1/2" />

                {/* Card */}
                <div
                  className={`flex-1 sm:w-1/2 pl-12 sm:pl-0 ${
                    left ? 'sm:pr-12 sm:text-right' : 'sm:pl-12'
                  }`}
                >
                  <div className="inline-block bg-[#12121a]/70 backdrop-blur-sm border border-[#D4AF37]/20 p-6 hover:border-[#D4AF37]/45 transition-colors duration-500">
                    <div className="font-display text-3xl font-bold text-gold-gradient mb-2">
                      {t.year}
                    </div>
                    <h3 className="font-display text-lg font-semibold text-[#F4E8C1] mb-2 tracking-wide">
                      {t.title}
                    </h3>
                    <p className="text-sm text-[#F4E8C1]/60 leading-relaxed font-light">
                      {t.text}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Smartest Capital badge */}
        <div className="mt-16 flex flex-col items-center gap-5 text-center">
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#F4E8C1]/45">
            Une Maison du Groupe
          </div>
          <a
            href="https://smartest-capital.org"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 px-8 py-4 border border-[#D4AF37]/40 hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-all duration-500"
          >
            <span className="font-display text-xl font-semibold text-gold-gradient tracking-[0.15em]">
              SMARTEST CAPITAL
            </span>
            <span className="text-[10px] text-[#F4E8C1]/60 group-hover:text-[#D4AF37] transition-colors uppercase tracking-[0.2em]">
              La Ville Dorée →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
